export default "/images/vendor/flag-icon-css/flags/4x3/lk.svg?3cb867c4401d5caa5bcfa6d87d2d436e";